import {
  ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges
} from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { QueryRef } from 'apollo-angular';
import { filter, map, startWith, switchMap, take, takeUntil } from 'rxjs/operators';

import {
  GetEntityById2, GetEntityById2GQL, GetEntityById2Query, GetEntityById2QueryVariables
} from 'generated/graphql';

import {
  CreateInvitiationFormModel
} from 'account/components/account-create/account-create.component';
import {
  ACCOUNT_ADDED_FROM_DIALOG, OPEN_CREATE_ACCOUNT_DIALOG
} from 'app/_state/account/account-actions';
import { selectCurrentCampaign } from 'app/_state/campaign-context/campaign-context-selectors';
import { CampaignContextState } from 'app/_state/campaign-context/campaign-context-state';
import { WithChangesSubject } from 'core/mixins/with-changes-subject';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { isNilOrEmpty, uuid } from 'helpers';

@Component({
  selector: 'app-entity-user-status',
  templateUrl: './entity-user-status.component.html',
})
export class EntityUserStatusComponent extends
  WithDisposableSubject(WithChangesSubject(class { }))
  implements OnInit, OnChanges {
  @Input() entityId: string;
  @Input() campaignId: string;

  entity: GetEntityById2.GetEntity;

  private _queryRef: QueryRef<GetEntityById2Query, GetEntityById2QueryVariables> = null;

  constructor(
    private actions: Actions,
    private _getEntityGQL: GetEntityById2GQL,
    private _store: Store<CampaignContextState>,
    private _cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    const keyChanges$ = this.watchForChangeKeys('entityId', 'campaignId').pipe(
      startWith({ campaignId: this.campaignId, entityId: this.entityId }),
      takeUntil(this.disposer),
      map(() => ({ campaignId: this.campaignId, entityId: this.entityId })),
      filter(({ campaignId, entityId }) => !isNilOrEmpty(campaignId) && !isNilOrEmpty(entityId))
    );

    keyChanges$.pipe(
      switchMap(({ campaignId, entityId }) => {
        this._queryRef = this._getEntityGQL.watch({
          entityId,
          campaignId,
          withEntityType: true,
          withBestEmail: true
        }, {
          fetchPolicy: 'cache-first'
        });
        return this._queryRef.valueChanges
          .pipe(
            takeUntil(this.disposer)
          );
      }
      ),
      map(({ data }) => data?.getEntity)
    ).subscribe((entity) => {
      this.entity = entity;
      this._cd.markForCheck();
    });

    this.actions.pipe(
      ofType(ACCOUNT_ADDED_FROM_DIALOG),
      takeUntil(this.disposer)
    ).subscribe(({ payload }) => {
      if (payload?.user?.linkedEntityId === this.entityId) {
        this._queryRef?.refetch();
      }
    });
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    super.ngOnChanges(simpleChanges);
  }

  onPromoteToUserClicked() {
    this._store.select(
      selectCurrentCampaign,
    ).pipe(
      take(1),
      map((currentCampaign) => {
        const data: CreateInvitiationFormModel = {
          email: this.entity.bestEmail?.email,
          firstName: this.entity.firstName,
          lastName: this.entity.lastName,
          linkedEntityId: this.entity.id,
          role: 'Activist',
          campaigns: [{
            campaign: currentCampaign,
            assignment: {
              tagIds: [],
              restrictionEnabled: true
            },
            uuid: uuid()
          }]
        };
        return data;
      })
    ).subscribe(
      (payload) => {
        this._store.dispatch(OPEN_CREATE_ACCOUNT_DIALOG({ payload }));
      }
    );
  }

}
